'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _constants = require('./constants');

var allowedSingleKeys = ['keywords', 'companyid', 'advertiserid', 'advertisergroup'];

function hasSingleKeyWithSingleValue(query) {
  var queryKeys = Object.keys(query);

  if (queryKeys.length !== 1) {
    return false;
  }

  var key = queryKeys[0];

  if (allowedSingleKeys.indexOf(key) === -1) {
    return false;
  }

  return query[key].indexOf(',') === -1;
}

exports['default'] = function (_ref) {
  var path = _ref.path;
  var query = _ref.query;

  if (path === '/') {
    return Object.keys(query).length > 0;
  }

  var page = query.page;

  var queryWithoutPage = _objectWithoutProperties(query, ['page']);

  if (parseInt(page, 10) > _constants.INDEX_UPTO_PAGE) {
    return true;
  }

  if (page) {
    return false;
  }

  if (Object.keys(queryWithoutPage).length === 0) {
    return false;
  }

  if (path !== '/jobs') {
    return true;
  }

  return !hasSingleKeyWithSingleValue(queryWithoutPage);
};

;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/is-qualified-url-nofollow.js
 ** module id = 549
 ** module chunks = 0
 **/